<main>
  <p-toast position="bottom-right" key="br"></p-toast>
  <loading-overlay [isLoading]="isLoading > 0"></loading-overlay>

  <header>
    <div class="headline">
      <h1>
        {{ isEditing ? ('Fabric_Title' | translateWF: 'Fabric') + ' ' + this.fabric?.fabricCode : ('Fabric_New' | translateWF: 'New Fabric') }}
      </h1>
      <csl-dropdown [enumObject]="statusesEnum" [enumValueOptions]="fabricStatusOptions" [formControl]="status" />
    </div>
    <div class="buttons">
      <button pButton class="cs-button-link" label="Manual" (click)="goToInternalLink()">
        <i class="pi pi-arrow-right"></i>
      </button>

      <span class="separator"></span>

      <p-button [label]="'Common_Save' | translateWF: 'Save'" [disabled]="!canEdit()" (click)="onSave()" />
      <p-button [label]="'Common_Cancel' | translateWF: 'Cancel'" variant="outlined" (click)="onCancel()" />
    </div>
  </header>

  <div class="content">
    <p-panel header="General Information">
      <p-card>
        <div class="col">
          <div class="grid-auto-4">
            <div class="form-box">
              <label for="fabricCode">{{ 'Fabric_Type_Prefix' | translateWF: 'Fabric Type Prefix' }}</label>
              <input
                id="fabricCode"
                type="text"
                [value]="fabricTypeCode.value?.code"
                [readOnly]="true"
                [disabled]="true"
                pInputText
                [ngClass]="{
                  'ng-invalid ng-dirty': formGroupSubmitted && fabricTypeCode.invalid,
                }"
              />
            </div>
            <div class="form-box">
              <label for="brandReference">{{ 'Fabric_Brand' | translateWF: 'Brand' }}</label>
              <p-autocomplete
                fluid
                #brandSearch="cslServerSearch"
                [cslServerSearch]="brandTypeTypeahead"
                [suggestions]="brandSearch.results()"
                field="name"
                [dropdown]="true"
                dropdownIcon="pi pi-search"
                [forceSelection]="true"
                [formControl]="brandReference"
                class="w-full"
                [ngClass]="{
                  'ng-invalid ng-dirty': formGroupSubmitted && brandReference.invalid,
                }"
              />
            </div>
            <div class="form-box">
              <label for="customerReference">{{ 'Fabric_Customer' | translateWF: 'Customer' }}</label>
              <p-autocomplete
                fluid
                #customerSearch="cslServerSearch"
                [cslServerSearch]="customerTypeTypeahead"
                [suggestions]="customerSearch.results()"
                field="name"
                [dropdown]="true"
                dropdownIcon="pi pi-search"
                [formControl]="customerReference"
                [forceSelection]="true"
                class="w-full"
                [ngClass]="{
                  'ng-invalid ng-dirty': formGroupSubmitted && customerReference.invalid,
                }"
              />
            </div>
          </div>
          <div class="grid-auto-2">
            <div class="form-box">
              <label for="longDescription">{{ 'Fabric_Description' | translateWF: 'Description' }}</label>
              <p>{{ getLongDescription() }}</p>
            </div>
            <div class="form-box-">
              <label>{{ 'Fabric_Pound_To_Yards' | translateWF: 'Pound to Yards' }}</label>
              <input type="text" [value]="convertLbsToYards" pInputText disabled />
            </div>
          </div>
        </div>
        <div class="grid-1 gap-[1rem]" *ngIf="userLite">
          <!-- <csl-standard-notes
            [notes]="notes"
            [userLite]="userLite"
            [viewOnly]="!canEdit()"
          ></csl-standard-notes> -->
        </div>
      </p-card>
    </p-panel>

    <!-- Reference Details -->
    <p-panel [header]="'Fabric_Details' | translateWF: 'Details'">
      <p-card>
        <div class="grid-auto-4">
          <div class="form-box">
            <label>{{ 'Fabric_ETE_Width' | translateWF: 'ETE Width' }}</label>
            <p-inputNumber
              [formControl]="endToEndWidth"
              class="w-full"
              [ngClass]="{
                'ng-invalid ng-dirty': formGroupSubmitted && endToEndWidth.invalid,
              }"
            />
          </div>
          <div class="form-box">
            <label for="gsm">{{ 'Fabric_GSM' | translateWF: 'GSM' }}</label>
            <p-inputNumber
              [formControl]="gramsPerSquareMeter"
              class="w-full"
              [ngClass]="{
                'ng-invalid ng-dirty': formGroupSubmitted && gramsPerSquareMeter.invalid,
              }"
            />
          </div>
          <div class="form-box">
            <label>{{ 'Fabric_Form' | translateWF: 'Fabric Form' }}</label>
            <p-select [formControl]="fabricForm" [options]="fabricFormOptions" />
          </div>
          <div class="form-box" *ngIf="fabricForm?.value === 0">
            <label for="gsm">{{ 'Fabric_Needle_Drop' | translateWF: 'Needle Drop' }}</label>
            <csl-dropdown-master-data [formControl]="needleDropCode" categoryCode="NeedleDrop" [allowCreate]="false" />
          </div>
        </div>
      </p-card>
    </p-panel>

    <p-panel *ngIf="greige && greige.value" [header]="'Commercial_Composition' | translateWF: 'Commercial Composition'">
      <p-card>
        <div class="col">
          <!-- Percentage Validation Error -->
          <div *ngIf="commercialCompositionEntries.length > 0 && !isCommercialCompositionPercentageValid()">
            <p-message severity="error">
              {{ 'Composition_Percentage_Error' | translateWF: 'Composition percentages must sum to 100%' }}
              ({{ getTotalCommercialCompositionPercentage() }}%)
            </p-message>
          </div>

          <!-- Composition Entries -->
          @for (entry of commercialCompositionEntries.controls; track $index; let i = $index) {
            <div class="grid-auto-4">
              <div class="form-box">
                <label *ngIf="i === 0">{{ 'Percentage' | translateWF: 'Percentage' }}</label>
                <p-inputGroup>
                  <p-inputNumber
                    [formControl]="$any(entry.get('percentage'))"
                    [minFractionDigits]="0"
                    [maxFractionDigits]="2"
                    [min]="0.01"
                    [max]="100"
                    [ngClass]="{
                      'ng-invalid ng-dirty': formGroupSubmitted && entry.get('percentage')?.invalid,
                    }"
                  ></p-inputNumber>
                  <p-inputgroup-addon>%</p-inputgroup-addon>
                </p-inputGroup>
              </div>
              <div class="form-box" style="min-width: 300px">
                <label *ngIf="i === 0">{{ 'Composition' | translateWF: 'Composition' }}</label>
                <p-treeSelect
                  [formControl]="$any(entry.get('selectedNode'))"
                  [options]="getCompositionTreeNodesForEntry(i)"
                  placeholder="{{ 'Select_Composition' | translateWF: 'Select Composition' }}"
                  class="w-full"
                  style="min-width: 300px"
                  selectionMode="single"
                />
              </div>
            </div>
          }

          <!-- Commercial Display Name -->
          <div class="form-box">
            <label>{{ 'Commercial_Display_Name' | translateWF: 'Commercial Display Name' }}</label>
            <div class="p-3 bg-gray-100 rounded-md text-lg font-medium">
              {{ getCommercialDisplayName() }}
            </div>
          </div>
        </div>
      </p-card>
    </p-panel>

    <!-- Greige -->
    <p-panel [header]="'Greige_Title' | translateWF: 'Greige'">
      <p-card>
        <div class="col">
          <div class="row-start-center gap-[1rem]" *ngIf="greige.value?.greigeCode">
            <span>{{ 'Greige_Code' | translateWF: 'Greige Code' }}:</span>
            <a class="font-bold text-primary cursor-pointer hover:underline" (click)="navigateToGreige(greige.value!.id!)">
              {{ greige.value?.greigeCode }}
            </a>
            <p-tag [value]="getGreigeStatusLabel(greige.value!.status) | pascalToNormalCase" [severity]="getGreigeStatusSeverity(greige.value!.status)" />
          </div>
          <div class="form-box-row">
            <label for="">{{ 'Greige_Title' | translateWF: 'Greige' }}</label>
            <p-autocomplete
              fluid
              #greigeSearch="cslServerSearch"
              [cslServerSearch]="fetchGreiges"
              [suggestions]="greigeSearch.results()"
              [dropdown]="true"
              field="fieldToDisplay"
              [formControl]="greige"
              [typeahead]="true"
              class="w-full"
              [forceSelection]="true"
              [ngClass]="{
                'ng-invalid ng-dirty': formGroupSubmitted && !greige.value?.id,
              }"
            >
              <ng-template pTemplate="item" let-item>
                <div class="p-list-item">
                  <div class="row-between-stretch gap-2 w-full">
                    <span>
                      <b>{{ item.greigeCode }}</b>
                    </span>
                    <span>{{ item.longDescription }}</span>
                    <span class="text-gray-500">{{ getLoopLengthsDisplay(item) }}</span>
                  </div>
                </div>
              </ng-template>

              <!-- Template para mostrar el valor seleccionado -->
              <ng-template pTemplate="selectedItem" let-item>
                <div *ngIf="item" class="row-sm">
                  <span
                    ><b>{{ item.greigeCode }}</b></span
                  >
                  <span>{{ item.longDescription }}</span>
                  <span class="text-gray-500">{{ getLoopLengthsDisplay(item) }}</span>
                </div>
              </ng-template>
            </p-autocomplete>
          </div>
          <div class="grid-2 gap-[1rem]">
            <div class="col">
              @if (greige && greige.value) {
                <div class="form-box-row">
                  <label for="">{{ 'Greige_Wraps_Per_Inch' | translateWF: 'Wraps Per Inch' }}</label>
                  <input
                    class="w-full process__input p-inputtext p-component p-inputnumber-input p-filled"
                    type="number"
                    [readOnly]="true"
                    [disabled]="true"
                    [value]="greige.value.wrapsPerInch"
                  />
                </div>

                <div class="form-box-row">
                  <label for="">{{ 'Greige_Courses_Per_Inch' | translateWF: 'Courses Per Inch' }}</label>
                  <input
                    class="w-full process__input p-inputtext p-component p-inputnumber-input p-filled"
                    type="number"
                    [readOnly]="true"
                    [disabled]="true"
                    [value]="greige.value.coursesPerInch"
                  />
                </div>

                <div class="form-box-row">
                  <label for="">{{ 'Greige_Fabric_Prefix' | translateWF: 'Fabric Prefix Code' }}</label>
                  <input
                    class="w-full process__input p-inputtext p-component p-inputnumber-input p-filled"
                    type="text"
                    [readOnly]="true"
                    [disabled]="true"
                    [value]="greige.value.fabricPrefix"
                  />
                </div>
              }
            </div>
            @if (greige && greige.value) {
              <div>
                <app-card-composition [fabricComposition]="greige.value.fabricComposition" [allCompositions]="allCompositions" />
              </div>
            }
          </div>
        </div>
      </p-card>
    </p-panel>

    <!-- Machine Information -->
    <p-panel *ngIf="asset" [header]="'Greige_Machine_Information' | translateWF: 'Machine Information'">
      <p-card>
        <div class="grid-auto-4">
          <div class="form-box">
            <label for="type">{{ 'Greige_Machine_Asset' | translateWF: 'Asset ID' }}</label>
            <input type="text" pInputText [value]="asset.assetId" [readOnly]="true" [disabled]="true" />
          </div>
          <div class="form-box">
            <label>{{ 'Greige_Machine_Diameter' | translateWF: 'Diameter' }}</label>
            <input type="text" [value]="asset.knittingMachineDetails?.diameterInches" [readOnly]="true" [disabled]="true" pInputText />
          </div>
          <div class="form-box">
            <label>{{ 'Greige_Machine_Gauge' | translateWF: 'Gauge' }}</label>
            <input type="text" [value]="asset.knittingMachineDetails?.gauge" [readOnly]="true" [disabled]="true" pInputText />
          </div>
          <div class="form-box">
            <label>{{ 'Greige_Machine_Cylinder_Needles' | translateWF: 'Cylinder Needles' }}</label>
            <input type="text" [value]="asset.knittingMachineDetails?.cylinderNeedles" [readOnly]="true" [disabled]="true" pInputText />
          </div>
          <div class="form-box" *ngIf="asset.knittingMachineDetails?.dialNeedles">
            <label>{{ 'Greige_Machine_Dial_Needles' | translateWF: 'Dial Needles' }}</label>
            <input type="text" [value]="asset.knittingMachineDetails?.dialNeedles" [readOnly]="true" [disabled]="true" pInputText />
          </div>
          <div class="form-box">
            <label>{{ 'Greige_Machine_Feeders' | translateWF: 'Feeders' }}</label>
            <input type="text" [value]="asset.knittingMachineDetails?.feeders" [readOnly]="true" [disabled]="true" pInputText />
          </div>
        </div>
      </p-card>
    </p-panel>

    @if (asset && asset.knittingMachineDetails) {
      <app-yarn-info *ngIf="greige && asset" [yarnInfo]="yarnInfo" [needles]="needles" [readonly]="true" [showTitle]="false" />
    }
    <p-panel [header]="'Fabric_Process_Loss' | translateWF: 'Process Loss'">
      <ng-template pTemplate="icons">
        <button pButton class="cs-button-link" label="Manual" (click)="goToInternalLink('process-loss')">
          <i class="pi pi-arrow-right"></i>
        </button>
      </ng-template>

      <p-card>
        <div class="grid-auto-3 items-end">
          <div class="form-box">
            <label for="">{{ 'Fabric_Dyeing_Finishing_Loss_User' | translateWF: 'Dyeing and Finishing Loss (User %)' }}</label>
            <p-inputGroup>
              <p-inputNumber
                [ngClass]="{
                  'ng-invalid ng-dirty': formGroupSubmitted && dyeingAndFinishingLossPercentage.invalid,
                }"
                [minFractionDigits]="2"
                [maxFractionDigits]="2"
                [formControl]="dyeingAndFinishingLossPercentage"
              ></p-inputNumber>
              <p-inputgroup-addon>%</p-inputgroup-addon>
            </p-inputGroup>
          </div>
          <div class="form-box">
            <label for="">{{ 'Fabric_Dyeing_Finishing_Loss_Internal' | translateWF: 'Internal Value (System %)' }}</label>
            <p-inputGroup>
              <p-inputNumber [minFractionDigits]="2" [maxFractionDigits]="2" [formControl]="dyeingAndFinishingLossInternalPercentageControl"></p-inputNumber>
              <p-inputgroup-addon>%</p-inputgroup-addon>
            </p-inputGroup>
          </div>
        </div>
      </p-card>
    </p-panel>

    <!-- Finishing Details -->
    <p-panel [formGroup]="finishingDetails" [header]="'Fabric_Finishing_Details' | translateWF: 'Finishing Details'">
      <div class="col-sm">
        <p-card>
          <div class="grid-auto-4">
            <div class="form-box">
              <label for="finishType">{{ 'Fabric_Finishing_Type' | translateWF: 'Finishing Type' }}</label>
              <csl-dropdown-master-data
                class="w-full"
                formControlName="finishTypeCode"
                categoryCode="FinishType"
                (onDelete)="handleDelete($event)"
                (onUpdate)="handleUpdate($event)"
                (emitMessagesApi)="showMessagesApi($event)"
                [allowCreate]="false"
              />
            </div>

            <div class="form-box">
              <label for="finishAppearance">{{ 'Fabric_Finishing_Appearance' | translateWF: 'Finishing Appearance' }}</label>
              <csl-dropdown-master-data
                class="w-full"
                formControlName="finishAppearanceCode"
                (onDelete)="handleDelete($event)"
                (onUpdate)="handleUpdate($event)"
                (emitMessagesApi)="showMessagesApi($event)"
                categoryCode="FinishAppearance"
                [allowCreate]="false"
              />
            </div>

            <div class="form-box">
              <label for="handFeelType">{{ 'Fabric_Hand_Feel_Type' | translateWF: 'Hand Feel Type' }}</label>
              <csl-dropdown-master-data
                class="w-full"
                formControlName="handFeelTypeCode"
                (onDelete)="handleDelete($event)"
                (onUpdate)="handleUpdate($event)"
                (emitMessagesApi)="showMessagesApi($event)"
                categoryCode="HandFeelType"
                [allowCreate]="false"
              />
            </div>

            <div class="form-box">
              <label for="packingType">{{ 'Fabric_Packing_Type' | translateWF: 'Packing Type' }}</label>
              <csl-dropdown-master-data
                class="w-full"
                formControlName="packingTypeCode"
                categoryCode="PackingType"
                (onDelete)="handleDelete($event)"
                (onUpdate)="handleUpdate($event)"
                (emitMessagesApi)="showMessagesApi($event)"
                [allowCreate]="false"
              />
            </div>
          </div>
        </p-card>

        <div class="grid-auto-2 gap-2">
          <p-panel data-tone="surface" [header]="'Fabric_Process' | translateWF: 'Process'">
            <p-card>
              <div class="col">
                @for (process of allProcesses; track $index) {
                  <div class="form-box-row">
                    <label for="">
                      {{ translateProcesses(process.name.en) }}
                    </label>

                    <div class="row-center-center">
                      <p-button severity="secondary" icon="pi pi-minus-circle" [disabled]="!canEdit()" (click)="removeProcessToFinishingRoute(process.processId)" />
                      <input
                        class="process__input p-inputtext p-component p-inputnumber-input p-filled"
                        type="number"
                        [readOnly]="true"
                        [disabled]="true"
                        [value]="getProcessCount(process.processId)"
                      />
                      <p-button severity="secondary" icon="pi pi-plus-circle" [disabled]="!canEdit()" (click)="addProcessToFinishingRoute(process.processId)" />
                    </div>
                  </div>
                }
              </div>
            </p-card>
          </p-panel>
          <p-panel data-tone="surface" [header]="'Fabric_Finishing_Route' | translateWF: 'Finishing Route'">
            <p-card>
              <div class="primary__card">
                <p class="error">
                  {{ 'Fabric_Route_Warning' | translateWF: 'This route will be followed in production.' }}
                </p>
                <ul cdkDropList class="cs-pattern" (cdkDropListDropped)="dropProcess($event)">
                  <li *ngFor="let process of getProcesses()" cdkDrag>
                    <div class="flex">
                      <span class="material-icons">menu</span>
                      <p>{{ translateProcesses(process.name.en) }}</p>
                    </div>
                  </li>
                </ul>
              </div>
            </p-card>
          </p-panel>
        </div>
      </div>
    </p-panel>
  </div>
</main>
